<script>
  import Button     from '/components/Button'
  import Progress   from '/components/Progress'
  import animations from '/lib/animations'
  import { fly }    from 'svelte/transition'

  export let recording = {
    lesson: 'Now playing',
    title : 'Here is silence',
    hash  : null
  }

  let currentTime = 0
  let duration    = 0
  let paused      = true
  let waiting     = true
</script>

<style lang="scss">
  .player {
    position: relative;

    h3 {
      margin-top: $GU / 2;
    }
  }
</style>

<div class="player" in:fly={animations.in} out:fly={animations.out}>
  <Button bind:paused bind:waiting />
  <h2>{recording.lesson}</h2>
  <h3>{recording.title}</h3>
  <Progress bind:currentTime bind:duration />
  <audio
    bind:currentTime
    bind:duration
    bind:paused
    on:seeking={       () => (waiting = true)}
    on:waiting={       () => (waiting = true)}
    on:seeked={        () => (waiting = false)}
    on:play={          () => (waiting = false)}
    on:playing={       () => (waiting = false)}
    on:canplaythrough={() => (waiting = false)}
    on:emptied={       () => (paused = true)}
    on:loadedmetadata={() => {
      waiting     = false
      paused      = true
      currentTime = 0
    }}
    on:ended={() => {
      paused      = true
      currentTime = 0
    }}
    src={'https://gateway.pinata.cloud/ipfs/' + recording.hash}
    preload="metadata"/>
</div>
